@import "~@govbr-ds/core/src/components/step/step";

:host {
  .br-step {
    display: flex;
    width: 100%;

    &.vertical {
      flex-direction: column;
      align-items: flex-start;
    }

    &.horizontal {
      flex-direction: row;
      justify-content: center;
    }
  }
}

::slotted([disabled]) {
  opacity: 1 !important;
}
